var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyNftsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7564 3.82844L7.23416 0.0628125C7.08913 -0.0209375 6.91045 -0.0209375 6.76541 0.0628125L0.243164 3.82844C0.0981328 3.91216 0.00878906 4.06691 0.00878906 4.23438V11.7656C0.00878906 11.9331 0.0981328 12.0878 0.243164 12.1716L6.76541 15.9372C6.91045 16.0209 7.08913 16.0209 7.23416 15.9372L13.7564 12.1716C13.9014 12.0878 13.9908 11.9331 13.9908 11.7656V4.23438C13.9908 4.06691 13.9015 3.91216 13.7564 3.82844ZM13.0533 11.495L6.99979 14.99L0.946289 11.495V4.505L6.99979 1.01003L13.0533 4.505V11.495Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77402 6.025C4.51515 6.025 4.30527 6.23488 4.30527 6.49375V8.36753L3.44943 6.31347C3.37665 6.13878 3.20596 6.025 3.01674 6.025H2.51465C2.25577 6.025 2.0459 6.23488 2.0459 6.49375V9.50625C2.06896 10.1275 2.96055 10.1271 2.9834 9.50625V7.6325L3.83924 9.68653C3.91202 9.86122 4.08271 9.975 4.27193 9.975H4.77402C5.0329 9.975 5.24277 9.76513 5.24277 9.50625V6.49375C5.24277 6.23488 5.0329 6.025 4.77402 6.025Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0625 6.49375V9.50625C6.08556 10.1275 6.97716 10.1271 7 9.50625V8.71978H8.00416C8.62544 8.69672 8.62497 7.80513 8.00416 7.78228H7V6.9625H8.50625C9.12753 6.93944 9.12706 6.04785 8.50625 6.025H6.53125C6.27237 6.025 6.0625 6.23488 6.0625 6.49375Z",
    fill: "#242424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76169 6.9625H10.2971V9.50625C10.3202 10.1275 11.2118 10.1271 11.2346 9.50625V6.9625H11.77C12.3913 6.93944 12.3908 6.04785 11.77 6.025H9.76166C9.14041 6.04806 9.14088 6.93966 9.76169 6.9625Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNftsIcon);
export default __webpack_public_path__ + "static/media/my-nfts-icon.72a7bfc62c5fe1b3b2aa59a29326a5a6.svg";
export { ForwardRef as ReactComponent };